import gql from 'graphql-tag';
import { FRAGMENT_DYNAMIC_ZONES } from 'src/modules/layout/components/dynamicZone/queries';

export const QUERY_JOBS_LISTING = gql`
  query JobsListing {
    jobs {
      id
      title_en
      title_de
      type
      slug
      start_date
      only_german
      city {
        name_en
        name_de
        country {
          name_en
          name_de
        }
      }
    }
  }
`;

export const QUERY_CAREERS_PAGE = gql`
  query Careers {
    career {
      title_en
      title_de
      normal_jobs_headline_en
      normal_jobs_headline_de
      educational_jobs_headline_de
      educational_jobs_headline_en
      dynamic_content_top {
        ...dynamicZone
      }
      dynamic_content_bottom {
        ...dynamicZone
      }
    }
  }
  ${FRAGMENT_DYNAMIC_ZONES}
`;
